"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SendMembersTable = void 0;
const lodash_1 = __importStar(require("lodash"));
const react_1 = __importStar(require("react"));
const styled_components_1 = __importStar(require("styled-components"));
const GlobalStateProvider_1 = require("../../../../GlobalStateProvider");
const common_1 = require("../../../../common");
const server_1 = require("../../../../server");
const classes_1 = require("../../../base/classes");
const SendMemberHeader_1 = require("./SendMemberHeader");
const SendMembersTableStyled = styled_components_1.default.div `
	display: flex;
	flex-direction: column;
	gap: 14px;
	align-items: flex-start;
	justify-content: flex-start;
	flex-shrink: 0;
	position: relative;

	.name {
		color: var(--color-black, #101010);
		text-align: left;
		font-family: var(--b4-font-family, 'Noto Sans KR', sans-serif);
		font-size: var(--b4-font-size, 14px);
		line-height: var(--b4-line-height, 28px);
		font-weight: var(--b4-font-weight, 400);
		position: relative;
		text-overflow: ellipsis;
		overflow: hidden;
		white-space: nowrap;
	}

	.dropdown {
		width: 100%;
	}

	.body-item {
		position: relative;
	}

	.dropdown-list {
		top: 48px;
	}

	.sms-member-list {
		.scroll-content {
			display: flex;
			flex-direction: column;
			gap: 0px;
			align-items: flex-start;
			justify-content: flex-start;
			position: relative;
			overflow: auto;
		}
	}

	.paging {
		margin-top: 20px;
		gap: 10px;

		button {
			width: 18px;
			height: 18px;

			p {
				min-width: unset;
			}
		}
	}

	${props => (props.$isMobile ? mobileStyles : props.$isTablet ? tabletStyles : desktopStyles)}
`;
const mobileStyles = (0, styled_components_1.css) `
	.table-item-wrap {
		.body-item {
			width: unset;
		}
	}

	.check-btn {
		padding: 8px 0;
	}

	.sms-member-list {
		display: flex;
		flex-direction: column;
		gap: 0px;
		align-items: flex-start;
		justify-content: flex-start;
		flex-shrink: 0;
		position: relative;
		overflow: hidden;
		flex: 1;

		.item {
			border-style: solid;
			border-color: var(--color-grey-c, #e6e8ed);
			border-width: 1px 0px 0px 0px;
			padding: 12px 0px 12px 0px;
			display: flex;
			flex-direction: row;
			align-items: center;
			justify-content: flex-start;
			flex-shrink: 0;

			p {
				color: var(--color-black, #101010);
				text-align: left;
				font-family: var(--b4-font-family, 'Noto Sans KR', sans-serif);
				font-size: 12px;
				line-height: 150%;
				letter-spacing: -0.02em;
				font-weight: 400;
			}

			.grey {
				color: var(--color-grey-l, #83868a);
				font-size: var(--b4-font-size, 12px);
			}
		}
	}

	.table-header-item {
		padding-bottom: 10px;
	}
	.all-checked {
		font-size: 12px;
	}
`;
const tabletStyles = (0, styled_components_1.css) `
	background: var(--color-white, #ffffff);
	display: flex;
	flex-direction: column;
	gap: 14px;
	align-items: center;
	justify-content: flex-start;
	flex-shrink: 0;
	position: relative;
	min-width: 150px;
	flex: 1;

	.sms-member-list {
		display: flex;
		flex-direction: column;
		gap: 0px;
		align-items: flex-start;
		justify-content: flex-start;
		position: relative;
		align-self: stretch;
		flex: 1;

		.table-header {
			background: var(--color-silver, #f3f4f8);
			border-style: solid;
			border-color: var(--color-grey-w, #b6bac0);
			border-width: 1px 0px 0px 0px;
			padding: 10px 16px 10px 16px;
			display: flex;
			flex-direction: row;
			gap: 6px;
			align-items: center;
			justify-content: flex-start;
			flex-shrink: 0;

			position: relative;
			text-align: left;
			font-family: var(--b4-font-family, 'Noto Sans KR', sans-serif);
			font-size: 12px;
			line-height: 150%;
			letter-spacing: -0.02em;
			font-weight: 400;
			position: relative;

			.table-header-item {
				min-width: unset !important;
				svg {
					width: 18px;
					min-width: unset;
				}
			}
		}

		.item {
			border-style: solid;
			border-color: var(--color-silver, #f3f4f8);
			border-width: 0px 0px 1px 0px;
			padding: 12px 16px 12px 16px;
			display: flex;
			flex-direction: row;
			gap: 6px;
			align-items: center;
			justify-content: flex-start;
			flex-shrink: 0;
			position: relative;

			color: var(--color-black, #101010);
			text-align: left;
			font-family: var(--b4-font-family, 'Noto Sans KR', sans-serif);
			font-size: 12px;
			line-height: 150%;
			letter-spacing: -0.02em;
			font-weight: 400;
			position: relative;

			.body-item {
				min-width: unset !important;
				.checkbox-item {
					svg {
						width: 18px;
						min-width: unset;
					}
				}
			}
		}
	}
`;
const desktopStyles = (0, styled_components_1.css) `
	background: var(--color-white, #ffffff);
	border-radius: 10px;
	border-style: solid;
	border-color: var(--color-grey-c, #e6e8ed);
	border-width: 1px;
	padding: 24px;
	display: flex;
	flex-direction: column;
	gap: 14px;
	align-items: center;
	justify-content: flex-start;
	flex-shrink: 0;
	position: relative;
	min-width: 215px;
	flex: 1;

	.sms-member-list {
		display: flex;
		flex-direction: column;
		gap: 0px;
		align-items: flex-start;
		justify-content: flex-start;
		position: relative;
		align-self: stretch;
		flex: 1;

		.table-header {
			background: var(--color-silver, #f3f4f8);
			border-style: solid;
			border-color: var(--color-grey-w, #b6bac0);
			border-width: 1px 0px 0px 0px;
			padding: 10px 16px 10px 16px;
			display: flex;
			flex-direction: row;
			gap: 20px;
			align-items: center;
			justify-content: flex-start;
			flex-shrink: 0;

			position: relative;
			text-align: left;
			font-family: var(--b4-font-family, 'Noto Sans KR', sans-serif);
			font-size: var(--b4-font-size, 14px);
			line-height: var(--b4-line-height, 28px);
			letter-spacing: var(--b4-letter-spacing, -0.02em);
			font-weight: var(--b4-font-weight, 400);
			position: relative;
		}

		.item {
			border-style: solid;
			border-color: var(--color-silver, #f3f4f8);
			border-width: 0px 0px 1px 0px;
			padding: 12px 16px 12px 16px;
			display: flex;
			flex-direction: row;
			gap: 20px;
			align-items: center;
			justify-content: flex-start;
			flex-shrink: 0;
			position: relative;

			p {
				color: var(--color-black, #101010);
				text-align: left;
				font-family: var(--b4-font-family, 'Noto Sans KR', sans-serif);
				font-size: var(--b4-font-size, 14px);
				line-height: var(--b4-line-height, 28px);
				letter-spacing: var(--b4-letter-spacing, -0.02em);
				font-weight: var(--b4-font-weight, 400);
				position: relative;
			}
		}
	}
`;
exports.SendMembersTable = react_1.default.memo(({ isReceiver, isCheckBox = true, receiverMemberList, setMemberData, }) => {
    const classesId = (0, classes_1.getClassesId)();
    const { isDesktop, isTablet, isMobile } = (0, GlobalStateProvider_1.useGlobalState)();
    const [page, setPage] = (0, react_1.useState)(0);
    const [previousPage, setPreviousPage] = (0, react_1.useState)(0);
    const [count, setCount] = (0, react_1.useState)(4);
    const [testData, setTestData] = (0, react_1.useState)([]);
    const [totalCount, setTotalCount] = (0, react_1.useState)(0);
    const [checkList, setCheckList] = (0, react_1.useState)([]);
    const [selectedChecklistMembers, setSelectedChecklistMembers] = (0, react_1.useState)({});
    const [hasExecuted, setHasExecuted] = (0, react_1.useState)([]);
    const [defaultCheckMembers, setDefaultCheckMembers] = (0, react_1.useState)([]);
    const [searchOption, setSearchOption] = (0, react_1.useState)({
        type: undefined,
        status: undefined,
        name: undefined,
    });
    // 참가자 목록 가져오기
    const { data, refetch } = (0, server_1.useMemberInfo)({
        ...searchOption,
        class_id: classesId,
        // status: 'created',
        level: ['03'],
        offset: page === 0 ? 0 : page * count,
        limit: count,
    });
    (0, react_1.useEffect)(() => {
        const resetCheck = props => {
            if (props?.no_phone_number?.length > 0) {
                const newTestData = props.testData
                    .filter(item => {
                    if (!props.no_phone_number.includes(item.id) &&
                        props.checkList.includes(item.id)) {
                        return item.id;
                    }
                })
                    .map(item => item.id);
                setSelectedChecklistMembers(prevState => {
                    return {
                        ...prevState,
                        [props.page]: newTestData,
                    };
                });
                setCheckList(newTestData);
                APP.eventManager.publish('UPDATE_TABLE_ITEM', {
                    className: 'sms-send-list',
                    defaultChekList: newTestData,
                });
            }
            else {
                setSelectedChecklistMembers({});
                setCheckList([]);
                APP.eventManager.publish('UPDATE_TABLE_ITEM', { className: 'sms-member-list' });
            }
        };
        APP.eventManager.subscribe('CLEAR_CHECK_LIST', resetCheck);
        return () => {
            APP.eventManager.unsubscribe('CLEAR_CHECK_LIST', resetCheck);
        };
    }, []);
    (0, react_1.useEffect)(() => {
        if (data) {
            const { total_count, found_count, items } = data;
            if (found_count === 0 && total_count > 0) {
                const maxPage = Math.max(0, Math.ceil(total_count / 10) - 1);
                setPage(maxPage);
            }
            if (total_count > 0) {
                setTestData(items);
                setTotalCount(total_count);
                return;
            }
        }
        setTestData([]);
        setTotalCount(0);
    }, [data]);
    // (리스트 갱신
    const refetchList = (0, lodash_1.throttle)(refetch, 1000, { leading: true, trailing: false });
    (0, react_1.useEffect)(() => {
        setCount(4);
        refetchList();
    }, [searchOption, page, count]);
    //참여자 선택 시 페이지 이동을 해도 선택된 참여자가 유지되도록
    (0, react_1.useEffect)(() => {
        if (checkList.length > 0 && testData.length > 0) {
            const no_phone_number = testData.filter(item => checkList.includes(item.id) &&
                (!item.phone_number || item.phone_number === '-'));
            if (no_phone_number.length > 0) {
                alert('번호가 저장되어있지 않은 사용자가 있습니다.');
                APP.eventManager.publish('CLEAR_CHECK_LIST', {
                    no_phone_number: no_phone_number.map(item => item.id),
                    page,
                    testData,
                    checkList,
                });
            }
        }
        if (lodash_1.default.isEqual(hasExecuted, checkList) && page === previousPage) {
            if (checkList.length === 0) {
                setSelectedChecklistMembers(prevState => {
                    return {
                        ...prevState,
                        [page]: [],
                    };
                });
            }
            return;
        }
        if (previousPage === page && testData.length > 0) {
            setSelectedChecklistMembers(prevState => {
                return {
                    ...prevState,
                    [page]: checkList.length === 0
                        ? []
                        : testData.filter(item => checkList.includes(item.id)),
                };
            });
        }
        setPreviousPage(page);
    }, [checkList, page, testData, receiverMemberList]);
    (0, react_1.useEffect)(() => {
        if (selectedChecklistMembers) {
            const selectedMembers = Object.keys(selectedChecklistMembers)
                .map(index => selectedChecklistMembers[index])
                .flat();
            setMemberData(selectedMembers);
            setDefaultCheckMembers(selectedChecklistMembers[page]?.map(member => member.id));
        }
        else {
            setMemberData([]);
            setDefaultCheckMembers([]);
        }
    }, [selectedChecklistMembers]);
    const handlerMoreData = (page) => {
        setPage(page);
    };
    const { headTitleList, tableReadDataKeys } = react_1.default.useMemo(() => {
        const headTitleList = [
            ...(!isMobile ?
                [
                    { title: 'nameId', space: 2, sort: false },
                    { title: 'phoneNumber', space: 2, sort: false },
                ] : []),
        ];
        const tableReadDataKeys = [
            { title: 'nickname', space: 2, sort: false },
            { title: 'phone_number', space: 2, sort: false },
        ];
        // useMemo에서 반환
        return { headTitleList, tableReadDataKeys };
    }, []);
    // // 상단 레이아웃 검색 조건을 위한 action
    const handlerFilterList = (filter) => setSearchOption(filter);
    const renderTitle = (0, react_1.useMemo)(() => (react_1.default.createElement(SendMemberHeader_1.SendMemberHeader, { handlerFilterList: handlerFilterList, totalTableList: totalCount, isReceiver: isReceiver })), [searchOption, totalCount]);
    const renderItem = (item, styles) => {
        return tableReadDataKeys.map(headItem => (react_1.default.createElement("div", { key: headItem.title, className: "body-item", style: {
                flex: !isMobile && headItem.space,
                ...styles?.bodyItem,
            } },
            react_1.default.createElement("p", { className: "overText2" }, headItem.title === 'nickname'
                ? `${item[headItem.title]} (${item['identifier']})`
                : item[headItem.title]))));
    };
    return (react_1.default.createElement(SendMembersTableStyled, { "$isMobile": isMobile, "$isTablet": isTablet, className: "user-list" },
        renderTitle,
        react_1.default.createElement(common_1.Table, { className: "sms-member-list", forceShowheader: true, showCheckBox: isCheckBox, defaultCheckList: defaultCheckMembers ? defaultCheckMembers : [], disableIdList: receiverMemberList ? receiverMemberList.map(item => item.id) : [], isInfinite: false, data: testData, totalCount: totalCount, page: page, pagingCount: 5, showCount: count, sortDefault: "id", headTitleList: headTitleList, renderItem: renderItem, handlerCheckList: setCheckList, handlerMoreData: handlerMoreData, isKeepChecked: true, renderGuidItem: react_1.default.createElement(react_1.default.Fragment, null) })));
});
